import React from 'react';
import { Link } from 'gatsby';

import Layout from './../components/layout';
import SEO from '../components/seo';

const AboutPage = () => (
  <Layout withArchive>
    <SEO title="O mnie" />
    <h1>Cześć, mam na imię Sławek</h1>

    <p>Z wykształcenia jestem inżynierem budownictwa z doświadczeniem w prowadzeniu robót budowlanych dotyczących konstrukcji stalowych. Budownictwo to ciekawa branża, jednak moje zainteresowania pchnęły mnie do pogłębiania wiedzy z programowania. </p>

    <h2 style={{color: 'darkblue', textAlign: 'center'}}>Trafiłeś tu, bo szukam pracy.</h2>

    <p>Tak właśnie, Twoja obecność na tej stronie to nie przypadek, a link do niej musiał pochodzić z któregoś z moich profili na portalach z pracą.</p>
    
    <p> Poszukujesz kogoś do swojego zespołu? Może to właśnie moje umiejętności Cię zainteresują. Zapraszam zatem, zapoznaj się z moimi <strong><Link to="/contact">projektami</Link></strong>. </p>

    <p>Nie oszukujmy się, douczanie się w domu z tutoriali nie daje takiego samego efektu jak praktyka. Dlatego właśnie <strong>poszukuję stażu</strong> we Frontendzie, z nastawieniem na bibliotekę <strong>ReactJS</strong>, dzięki czemu mógłbym dalej rozwijać swoją wiedzę. </p>

    <h2>MOJE UMIEJĘTNOŚCI</h2>

    <p>Wykresy w stylu <em>"skills: CSS 80%, JS 60%"</em> uważam za bezsensowne, gdyż brak im realnego odniesienia. Na początku drogi zawodowej, jak można się domyślić, wszystkie moje umiejętności są na poziomie podstawowym. Równocześnie jednak, te właśnie początkowe tygodnie pracy w nowej branży przyniosą największy, zauważalny skok poziomu wiedzy. </p>
    
    <ul>
      <li><strong>HTML</strong> - często przy użyciu Emmeta, trzeba sobie ułatwiać życie</li>

      <li><strong>BEM Methodology/Naming Convention</strong> - chociaż obecnie raczej podział na komponenty w ReactJS załatwia temat</li>

      <li><strong>CSS</strong> - RWD, Flexbox, CSS Grid</li>

      <li><strong>Javascript</strong> - w podstawach już się czuję swobodnie, na konkretne zapotrzebowanie doczytuję również o bardziej złożonych zagadnieniach</li>

      <li><strong>ReactJS</strong> - tutoriale przerobione, samemu coś pisać już trudniej. Obecnie jednak tej tematyce poświęcam najwięcej czasu i poznaję coraz lepsze sposoby używania modularności komponentów i ich interakcji. </li>

      <li><strong>Git</strong> - nowe składniki stron rozwijam na branchach i je merguję, jednak robię to właściwie tylko na swojej kopii wysyłanej na GitHuba, nie dane mi nigdy było pracować w zespole i wykorzystać pełnej mocy tej technologii.</li>
    </ul>

    <h2>DODATKOWO:</h2>

    <ul>
      <li><strong>angielski</strong> - tutoriale i dokumentacja nie stanowią dla mnie problemu. Prowadziłem przez wiele miesięcy roboty budowlane za granicą (w tym ok. 1 rok w Anglii) i choć płynnością bym tego nie nazwał, porozumiewałem się bez problemu z kierownikami oraz innymi uczestnikami budowy np. na codziennych spotkaniach koordynacyjnych. </li>
      
      <li><strong>zarządzanie projektami</strong> - nie była to wprost metodyka <em>Scrum</em> czy <em>Agile</em>, gdyż budownictwo charakteryzuje się swoją specyfiką odmienną od IT, jednak znaleźć można również pewne elementy wspólne. Wiem także, jak ważna jest wymiana informacji między zespołem a osobą nim zarządzającą i dbam o to, aby ich przepływ pozwalał na bezproblemowe reagowanie na różnych etapach rozwoju projektu.</li>
      
      <li>Jako <strong>kierownik projektu</strong> odpowiadałem za projekty przed kierownictwem firmy. Współuczestniczyłem w negocjacjach z podwykonawcami oraz rozliczałem projekty po ich zakończeniu (przekazanie do klienta, odbiory).  </li>
    </ul>


    <h2 style={{color: 'darkblue', textAlign: 'center'}}>Zainteresowanych współpracą zapraszam do <Link to="/contact">kontaktu</Link>.</h2>

  </Layout>
)

export default AboutPage
